import moment from 'moment';
import {mpsTypes, requiredVehicleData, requiredVehicleDataNoEngine, fuelType} from '../types/vehicleTypes'

export const mapRegistrationValues = (obj) => {
    return Object.keys(obj).reduce((acc, key ) => {
        if(key === 'registrationType') {
            return {...acc, [key]: setRegType(obj[key])};
        }

        if(key === 'vehicleType') {
            const vehType =  setVehicleType(obj[key]) ? setVehicleType(obj[key]) : {value: null, userValue: null}
            return {...acc, [key]: vehType }
        }

        if(key === 'engineType') {
            return {...acc, [key]: setEngineType(obj[key])};
        }

        if(key === 'fuelType') {
            return {...acc, [key]: setFuelType(obj[key])};
        }

       const resObj = setValues(obj[key]);
        
       return {...acc, [key]: resObj}
    }, {})
}

// export const validateMappedRegValuesOld = (obj) => {
//     const validatedValues = Object.keys(requiredVehicleData).reduce((acc, curr) => {
//         if(curr === 'weightF1' || curr === 'weightG') {
//             if(obj[curr]?.value && (parseInt(obj[curr]?.value) !== 0)) {
//                 return {...acc}
//             }
//         }

//         if(obj[curr]?.value) {
//             return {...acc};
//         }

//         const value = requiredVehicleData[curr];
//         return {...acc, [curr]: {value, userValue: value}};
//     }, {});

//     return {...obj, ...validatedValues};
// }

// export const validateMappedRegValues = (obj) => {
//     if(!obj || (obj && Object.keys(obj).length === 0 )) return false;

//     for (let curr of Object.keys(requiredVehicleData)){
//         if(curr === 'weightF1' || curr === 'weightG') {
//             if(!obj[curr]?.value || !(parseInt(obj[curr]?.value) !== 0)) {
//                 return false;
//             }
//         } else {
//             if(!obj[curr]?.value) {
//                 return false;
//             }
//         }
//     };

//     return true;
// }

export const validateMappedRegValuesFull = (obj, vehicleType) => {
    if(!obj || (obj && Object.keys(obj).length === 0 )) return false;

    const requiredFields = (vehicleType === '8' || vehicleType === '9') ? Object.keys(requiredVehicleDataNoEngine) : Object.keys(requiredVehicleData)

    for (let curr of requiredFields){
        if(curr === 'weightF1' || curr === 'weightG') {
            if(!obj[curr]?.value || !(parseInt(obj[curr]?.value) !== 0)) {
                return false;
            }
        } else {
            if(!obj[curr]?.value) {
                return false;
            }
        }
    };

    return true;
}

export const mapRegPropsForOffers = (obj) => {
    if(!obj) return;
    return Object.keys(obj).reduce((acc, curr) => {
        return {...acc, [curr]: obj[curr].value}
    }, {});
}

const mapRegPropsForCreateContract = (obj) => {
    if(!obj) return;
    return Object.keys(obj).reduce((acc, curr) => {
        return {...acc, [curr]: {value: obj[curr].value, userValue: obj[curr].userValue}}
    }, {});
}

// export const mapVehicleInfoForOffers = (regProps, locationCode) => {
//     return {
//         registrationProps: mapRegPropsForOffers(regProps),
//         questions: mapQuestions(regProps, locationCode)
//     }
// }

export const mapVehicleInfoForOffersFull = (regProps, locationCode, questions) => {
    return {
        registrationProps: mapRegPropsForOffers(regProps),
        questions: mapQuestionsFull( locationCode, questions)
    }
}
//TO DO
export const mapVehicleInfoForRevisedOffer = (regProps, locationCode, questions, ownerDetails) => {
    return {
        registrationProps: mapRegPropsForOffers(regProps),
        questions: mapQuestionsFull( locationCode, questions),
        insurancePerson: mapInsurancePerson(ownerDetails)
    }
}

export const mapBodyForCreateContract = (state) => {

    const {insOffers: {revisedOffer}, insVehicleInfo, questionsPolicy, ownerDetails, shipmentDetails, userDetails} = state;
    const {registrationProps, location} = insVehicleInfo || {};
    const {insCompany, insuranceId} = revisedOffer || {};

    return {
        registrationProps   : mapRegPropsForCreateContract(registrationProps),
        questions           : mapQuestionsFull(location?.locationCode, questionsPolicy),
        insCompany          : insCompany,
        insuranceId         : insuranceId || null,
        insType             : "VEHICLE",
        insurancePerson     : mapInsurancePersonForContract(ownerDetails, userDetails, questionsPolicy.ownerType),
        insuranceDocuments  : mapInsDocuments(insVehicleInfo, insuranceId), 
        offer               : mapOffer(revisedOffer, registrationProps),
        deliveries          : mapShipmentDetails(shipmentDetails, 1)
    }
}

export const getPlateFirstLetters = (plate) => {
    if(!plate) return;
    const match = /[0-9]/.exec(plate);

    return match ? plate.substring(0, match.index) : plate;
}

export const findPlateDistrict = (disctricts, plate) => {
    if(!disctricts || !disctricts.length || !plate) return null;
    const plateFirstLetters = getPlateFirstLetters(plate.toUpperCase());

    return disctricts.reduce((acc, district) => {
        const plateCodes = district.plateCode;
        const plateCodesList = plateCodes ? plateCodes.split(' ') : [];

        const plateCode = plateCodesList.find(code => code === plateFirstLetters);

        return plateCode ? district.districtName : acc;

    }, null);
}

export const findLocationCode = (locations, districtName) => {
    if(!locations || !districtName) return null;
//console.log('locations', locations, 'districtName', districtName)

    return locations.reduce((acc, location) => {
        if(location.name === districtName || location.name === 'София') {
            return location.code;
        }

        return acc;
    }, null);
}

export const findLocationName = (locations, districtName) => {
    if(!locations || !districtName) return null;

    return locations.reduce((acc, location) => {
        if(location.name === districtName || location.name === 'София') {
            
            return location.name;
        }

        return acc;
    }, null);
}

export const findPlateCodeByDistrictName = (districts, districtName) => {
    if(!districts || !districtName) return null;

    return districts.reduce((acc, district) => {
        if(district.districtName === districtName) return district.plateCode.split(' ')[0];
        return acc;
    }, null);
}

export const mapInsCompMsgCode = (msgCode, installment) => {
    if( msgCode === "INSTALLMENTS_NOT_SUPPORTED_FOR_UNREGISTERED_VEHICLES" || 
        msgCode === "MULTIPLE_INSTALLMENTS_NOT_SUPPORTED_FOR_THIS_VEHICLE_TYPE" ||
        msgCode === "NOT_SUPPORTED_FOR_UNREGISTERED_VEHICLES" ||
        msgCode === "NO_APPLICATIONS_FOR_THIS_VEHICLE_TYPE" ) {
            
        if(installment === 1) {
            return "Не се предлага";
        } else {
            return "Не се предлага на вноски";
        }
    }

    if(msgCode === "APPLICATION_GENERATION_FAILED") {
        return "В момента няма връзка със застрахователя"
    }

    return "В момента няма връзка със застрахователя" 
}

export const mapNewUserAddress = (userAddress, isUserAddress, isNotDefaultDeliveryAddress) => {
    if(!userAddress) return;
    return {
        addressId               : userAddress.addressId ? userAddress.addressId : null,
        postalCode              : userAddress.postalCode || '',
        city                    : userAddress.city || '',
        state                   : userAddress.state || '',
        streetName              : userAddress.streetName || '',
        streetNumber            : userAddress.streetNumber || '',
        entrance                : userAddress.entrance || '',
        floor                   : userAddress.floor || '',
        apartment               : userAddress.apartment || '',
        addInfo                 : userAddress.addInfo || '',
        defaultDeliveryAddress  : isNotDefaultDeliveryAddress ? false : true,
        apartmentBuilding       : userAddress.apartmentBuilding || '',
        isUserAddress           : isUserAddress ? true : false,
    }
}

export const generateAddressString = (address, noAddInfo) => {
    if(!address) return;
    let {postalCode, city, streetName, streetNumber, apartmentBuilding, entrance, floor, apartment, addInfo} = address || {};
    apartmentBuilding = apartmentBuilding ? `, бл. ${apartmentBuilding}` : '';
    entrance          = entrance ? `, вх. ${entrance}` : '';
    floor             = floor ? `, ет. ${floor}` : '';
    apartment         = apartment ? `, ап. ${apartment}` : '';
    addInfo           = addInfo && !noAddInfo? `, Допълнителна информация: ${addInfo}` : '';


    return `гр. ${city}, ${postalCode}, ${streetName} ${streetNumber}${apartmentBuilding}${entrance}${floor}${apartment}${addInfo}`;
}

export const getRegValues = (regProps) => {
    if(!regProps) return;

    const getValue = (data) => {
        return data?.value ? data?.value : data?.userValue ? data?.userValue : null;
    }

    return {
        make  : getValue(regProps.make),
        model : getValue(regProps.model),
        plate : getValue(regProps.plate),
    }
}

export const findLastUnpaidCashflow = (cashFlows) => {
    if(!cashFlows || cashFlows?.length === 0) {return null; }

    cashFlows.sort((a, b) => a.cashflowId - b.cashflowId);

    return cashFlows.find(cashFlow => !cashFlow.paid);
}

export const findCurrentCashFlow = (cashFlows) => {
    if(cashFlows.length === 0) {return null; }

    cashFlows.sort((a, b) => a.cashflowId - b.cashflowId);

    const today = (new Date()).setHours(0, 0, 0, 0);
    
    return cashFlows.reduce((acc, cashFlow, i, arr) => {
            const cashFlowDueDate 	= new Date(cashFlow.dueDate);
            const accDueDate 		= new Date(acc.dueDate);
            if(accDueDate.getTime() < today  && today <= cashFlowDueDate.getTime()) {
                if(i > 0 && !arr[i-1].paid) {
                    return arr[i-1];
                }
                return cashFlow;
            }
            if(cashFlowDueDate.getTime() < today && i === (arr.length - 1)) {
                return cashFlow;
            }

            return acc;
        });
}

export const findLastPaidOrConDCashFlow = (cashFlows) => {
    if(cashFlows.length === 0) {return null; }

    cashFlows.sort((a, b) => a.cashflowId - b.cashflowId);

    const today = (new Date()).setHours(0, 0, 0, 0);
    
    return cashFlows.reduce((acc, cashFlow, i, arr) => {
            const cashFlowDueDate = new Date(cashFlow.dueDate);

            if (i === 0) {
                return cashFlow;
            }
            
            const previousDueDate = new Date(arr[i-1].dueDate);
            if(previousDueDate.getTime() < today  && today <= cashFlowDueDate.getTime()) {
//						if(!arr[i-1].paid || (arr[i-1].paid && !cashFlow.paid)) {
                if(!arr[i-1].paid || (arr[i-1].paid && (!cashFlow.paid && cashFlow.status !== 'CASH_ON_DELIVERY')) ) {
                    return arr[i-1];
                }
                
                return cashFlow;
            }
                                                    
            if(cashFlowDueDate.getTime() < today && i === (arr.length - 1)) {
                return cashFlow;
            }
 
            return acc;
        });
}

export const countDaysPastDueDate = (cashFlows) => {
    if(!cashFlows) return;

    const cashFlowCount = cashFlows.length;

    const lastPaidCashFlow = findLastPaidOrConDCashFlow(cashFlows);

    if(!lastPaidCashFlow) return;
   
    if (cashFlowCount === 1 || (lastPaidCashFlow?.cashflowId === lastPaidCashFlow.totalCashflows))  {
        if(lastPaidCashFlow?.paid) return null;
       
        const nextCashFlow = lastPaidCashFlow;
        const dateNow = moment();
        const dueDate = moment(nextCashFlow.dueDate);
        return dueDate.diff(dateNow, 'days');

    } else if(lastPaidCashFlow.cashflowId < lastPaidCashFlow.totalCashflows) {
        const nextCashFlow = cashFlows.find(cashFlow=>cashFlow.cashflowId === (lastPaidCashFlow.cashflowId + 1));
        const dateNow = moment();
        const dueDate = moment(nextCashFlow.dueDate);
        return dueDate.diff(dateNow, 'days');
    }
}

export const checkIfPolicyExpired = (policy) => {
    const dateNow = moment().utc();
    const expiryDate = moment(policy?.expireDate).utc();

    return dateNow > expiryDate;
}

export const findOtherActivePolicy = (policy, policies) => {
    const plate = policy?.registrationProps?.plate?.value;

    const activePolicy = policies.find(obj => {
        if(plate === obj?.registrationProps?.plate?.value && obj.status === "ACTIVE") {
            return true;
        }
        return false;
    });

    return activePolicy;
}

export const isOtherActivePolicyStopsNew = (policy, policies) => {
    const plate = policy?.registrationProps?.plate?.value;

    const activePolicy = policies.find((obj) => {
        if(plate === obj?.registrationProps?.plate?.value && obj.status === "ACTIVE") {
            return true;
        }
        return false;
    });

    if(!activePolicy) return false;

    const dateNow = moment().utc();

    const expiryDate = moment(activePolicy.expireDate).utc();

    const diffDays = expiryDate.diff(dateNow, 'days');

    if(diffDays > 15) return true;

    return false;
}

export const isCyrilicFound = (fieldValue) => {
    if (!fieldValue) return;
    return fieldValue.match(/[аАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯ]/) ? true : false;
}

export const isLatinFound = (fieldValue) => {
    if (!fieldValue) return;
    return fieldValue.match(/[a-zA-Z]/) ? true : false;
}

export const isNoCyrilicFound = (fieldValue) => {
    if (!fieldValue) return;
    return fieldValue.match(/[^аАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯ0-9.,\-\_'\s*$]/) ? true : false;
}

export const setInstallmentText = (cashflow) => {
    if(!cashflow) return null;

    switch (cashflow?.cashflowId) {
        case 1 :
            return `Плащане на 1-ва вноска`;
        case 2 :
            return `Плащане на 2-ра вноска`;
        case undefined :
            return `Плащане на вноска`;
        default:
            return `Плащане на ${cashflow?.cashflowId}-та вноска`;
    }
}

export const isPolicyAdded = (policy) => {
    if(!policy?.cashflows) return true;

    return !policy?.cashflows.find(cashflow => cashflow.cashflowId === 1);
}

export const isBeforeFirstCashflow = (policy) => {
    const cashflows = policy?.cashflows;

    if(!cashflows) return;

    cashflows.sort((a, b) => a.cashflowId - b.cashflowId);

    const dateNow = moment();
    const dueDate = moment(cashflows[0].dueDate);

    if((dueDate - dateNow) > 0) {
        return true
    }

    return false; 
}

export const daysToFirstCashFlow = (policy) => {
    const cashflows = policy?.cashflows;

    if(!cashflows) return;

    cashflows.sort((a, b) => a.cashflowId - b.cashflowId);

    const dateNow = moment();
    const dueDate = moment(cashflows[0].dueDate);

    return dueDate.diff(dateNow, 'days');
}

export const sortPoliciesByContractDate = (policyA, policyB) => {
    const dateA = moment(policyA.contractDate);
    const dateB = moment(policyB.contractDate);

    if(dateA > dateB){
        return -1;
    } else if (dateA < dateB) {
        return 1;
    } else { 
        return 0
    }
}

export const isPolicyExpired = (policy) => {
    if(!policy) return;

    return moment(policy?.expireDate) < moment();
}

function setValues(obj) {
    const newObj = {}
    if(!obj) {return {};}
    if(obj.valueExt === null) {
        if(obj.value === null) {
            newObj.userValue = '-'
        } else {
            newObj.userValue = obj.value;
        }
    } else {
        newObj.userValue = obj.valueExt;
    }

    newObj.value = obj.value;
    newObj.valueVIns = obj.valueVIns;

    return newObj;
}

function setRegType(obj) {
    if(!obj){return {};}
    if(obj.value === '2') {
        return {value: '2', userValue: 'Временна', valueVIns: obj.valueVIns}
    } else if (obj.value === '1') {
        return {value: '1', userValue: 'Постоянна', valueVIns: obj.valueVIns}
    }

    return {};
}

function setVehicleType(obj) {
    if(!obj) return null;
    const mpsTypesKeys = Object.keys(mpsTypes);

    const objValue = mpsTypesKeys.reduce((acc, curr) => {
        let valueExt = obj.valueExt;
        valueExt     = valueExt ? valueExt.toLowerCase() : null;
        let valueCur     = mpsTypes[curr].toLowerCase();

        //if(valueExt && valueExt.includes(mpsTypes[curr].toLowerCase())){
        if(valueExt && valueCur.includes(valueExt)){
            return {value : curr, userValue: mpsTypes[curr], valueVIns: obj.valueVIns};
        }

        return acc;
    }, null)

    return objValue;
}

function setEngineType(obj) {
    if(!obj) return {};

    const value = obj.value;

    if(value === '002' || value === '003' || value === '005' || value === '006' || value === '1' ) {
        return {value: '1', userValue: 'Бензин', valueVIns: obj.valueVIns};
    }

    if(value === '008' || value === '009' || value === '010' || value === '016' || value === '011') {
        return {value: '6', userValue: 'Друг', valueVIns: obj.valueVIns};
    }

    if(value === '013' || value === '014' || value === '2') {
        return {value : "2", userValue : "Дизел", valueVIns: obj.valueVIns};
    }

    if(value != null && fuelType[value]) {
        return {value : value, userValue : fuelType[value], valueVIns: obj.valueVIns};
    }

    return {value : null, userValue : null, valueVIns: obj.valueVIns};
}

function setFuelType(obj) {
    return setEngineType(obj);
}

function mapQuestions(regProps, locationCode){
    return {
        "commenceDate": moment().add(2, 'd').format('YYYY-MM-DD'), // "2021-04-08",
        "driverYearsOfPractice": "10",
        "driversAge": "35",
        "generalRegistrationType": "0",
        "isDriverForeigner": "0",
        "isInsurerForeigner": "0",
        "isRightWheelDrive": "0",
        "locationId": locationCode,
        "moreThan60DaysAbroad": "0",
        "ownerType": "0",
        "vehicleType": regProps['vehicleType']?.valueVIns,    //"1",
        "vehicleUsage": "1" // лични нужди
    }
}

function mapQuestionsFull( locationCode, questoins ) {

    return {
        "commenceDate": questoins?.commenceDate, // "2021-04-08",
        "driverYearsOfPractice": questoins?.driverYearsOfPractice,
        "driversAge": questoins?.driversAge,
        "generalRegistrationType": questoins?.generalRegistrationType,
        "isDriverForeigner": questoins?.isDriverForeigner,
        "isInsurerForeigner": questoins?.isInsurerForeigner,
        "isRightWheelDrive": questoins?.isRightWheelDrive,
        "locationId": locationCode,
        "moreThan60DaysAbroad": questoins?.moreThan60DaysAbroad,
        "ownerType": questoins?.ownerType,
        "vehicleType": questoins?.vehicleType,            //regProps['vehicleType']?.valueVIns,    //"1",
        "vehicleUsage": questoins?.vehicleUsage 
    }
}

function mapInsurancePerson(ownerDetails) {
    if(!ownerDetails) return;

    return {
        surname         : ownerDetails.middleName,
        surnameCyr      : ownerDetails.middleNameCyrillic,
        family          : ownerDetails.lastName,
        familyCyr       : ownerDetails.lastNameCyrillic,
        name            : ownerDetails.firstName,
        nameCyr         : ownerDetails.firstNameCyrillic,
        personPublicId  : ownerDetails.eik ? ownerDetails.eik : ownerDetails.personPublicId,
        personType      : ownerDetails.eik ? "COMPANY" : "INDIVIDUAL",
        nationality     : 'BG',
        gender          : null,
        birthDate       : null,
        postCode        : ownerDetails.ownerAddress?.postalCode,
        addressId       : ownerDetails.ownerAddress?.addressId,
        role            : "INSURED"
    }
}

function mapInsurancePersonForContract(ownerDetails, userDetails, ownerType) {
    if(!ownerDetails ) return;

    const userAddress = findUserAddress(userDetails.userAddresses);

    return [{
        surname         : ownerDetails.middleName,
        surnameCyr      : ownerDetails.middleNameCyrillic,
        family          : ownerDetails.lastName,
        familyCyr       : ownerDetails.lastNameCyrillic,
        name            : (ownerDetails.eik && (ownerType === "1")) ? ownerDetails.companyNameLatin : ownerDetails.firstName,
        nameCyr         : (ownerDetails.eik && (ownerType === "1")) ? ownerDetails.companyNameCyrillic : ownerDetails.firstNameCyrillic,
        personPublicId  : (ownerDetails.eik && (ownerType === "1")) ? ownerDetails.eik : ownerDetails.personPublicId,
        personType      : (ownerDetails.eik && (ownerType === "1")) ? "COMPANY" : "INDIVIDUAL",
        nationality     : 'BG',
        gender          : null,
        birthDate       : null,
        postCode        : ownerDetails.ownerAddress?.postalCode,
        addressId       : ownerDetails.ownerAddress?.addressId,
        role            : "INSURED"
    },{
        surname         : userDetails.middleName,
        surnameCyr      : userDetails.middleNameCyrillic,
        family          : userDetails.lastName,
        familyCyr       : userDetails.lastNameCyrillic,
        name            : userDetails.firstName,
        nameCyr         : userDetails.firstNameCyrillic,
        personPublicId  : userDetails.userPubId,
        personType      : "INDIVIDUAL",
        nationality     : 'BG',
        gender          : null,
        birthDate       : null,
        postCode        : userAddress.postalCode,
        addressId       : userAddress.addressId,
        role            : "INSURER"
    }]
}

function findUserAddress(userAddresses){
    return userAddresses.find(address => address.isUserAddress);
}

function mapOffer(revisedOffer, registrationProps){
    let {insCompany, installments, installmentsLEVA} = revisedOffer;
    installments = installments || [];
    const instLength = installments?.length;
    const instLengthLEVA = installmentsLEVA?.length;

    return {
        "policyNo"      : null,
        installment2    : (instLengthLEVA >= 2)  ? installmentsLEVA[1] : 0,
        installment2EUR    : (instLength >= 2)  ? installments[1] : 0,
        installment4    : (instLengthLEVA === 4) ? installmentsLEVA[3] : 0,
        installment4EUR    : (instLength === 4) ? installments[3] : 0,
        totalAmount     : revisedOffer.totalAmount,
        totalAmountEUR  : revisedOffer.totalAmountEUR,
        insCompany      : insCompany,
        installment3    : (instLengthLEVA === 4) ? installmentsLEVA[2] : 0,
        installment3EUR    : (instLength === 4) ? installments[2] : 0,
        contractDate    : revisedOffer.contractDate,
        commenceDate    : revisedOffer.commenceDate,
        expireDate      : revisedOffer.expireDate,
        installments    : instLength,
        externalId      : registrationProps?.plate?.value,
        policyId        : null,
        installment1    : installmentsLEVA[0],
        installment1EUR    : installments[0]
    }

    //  return {
    //     "policyNo"      : null,
    //     installment2    : (instLength >= 2)  ? installments[1] : 0,
    //     installment4    : (instLength === 4) ? installments[3] : 0,
    //     totalAmount     : revisedOffer.totalAmount,
    //     insCompany      : insCompany,
    //     installment3    : (instLength === 4) ? installments[2] : 0,
    //     contractDate    : revisedOffer.contractDate,
    //     commenceDate    : revisedOffer.commenceDate,
    //     expireDate      : revisedOffer.expireDate,
    //     installments    : instLength,
    //     externalId      : registrationProps?.plate?.value,
    //     policyId        : null,
    //     installment1    : installments[0]
    // }
}

function mapInsDocuments(insVehicleInfo, insuranceId) {
    const fileUploadId = insVehicleInfo?.talonPicture?.docId || null;

    //temp for testing
    //const fileUploadId = '1288';

    return [{
        insuranceId : insuranceId || null,
        fileUploadId : fileUploadId,
        docType      : 'talon',
        cashflowId   : '',
        externalRef  : ''
    }]
}

function mapShipmentDetails(shipmentDetails, cashflowId) {
    return [{
        cashflowId: cashflowId,
        addressId : shipmentDetails?.deliveryAddress?.addressId,
        receiverName      : shipmentDetails?.receiverName,
        receiverPhone     : shipmentDetails?.receiverPhone,
        receiverAddInfo   : shipmentDetails?.receiverAddInfo,
        }]
}

// {
//     "commenceDate": "2021-04-08",
//     "driverYearsOfPractice": "3",
//     "driversAge": "23",
//     "generalRegistrationType": "0",
//     "isDriverForeigner": "0",
//     "isInsurerForeigner": "0",
//     "isRightWheelDrive": "0",
//     "locationId": "68134",
//     "moreThan60DaysAbroad": "0",
//     "ownerType": "0",
//     "vehicleType": "1",
//     "vehicleUsage": "1"
// },

const cyrillicToLatinMap = {
    "0":"0",
    "1":"1",
    "2":"2",
    "3":"3",
    "4":"4",
    "5":"5",
    "6":"6",
    "7":"7",
    "8":"8",
    "9":"9",
    ".":".",
    "'":"‘",
    "‘":"‘",
    "’":"’",
    "“":"“",
    "”":"”",
    " ":" ",
    "-":"-",
    "А":"A",
    "Б":"B",
    "В":"V",
    "Г":"G",
    "Д":"D",
    "Е":"E",
    "Ж":"Zh",
    "З":"Z",
    "И":"I",
    "Й":"Y",
    "К":"K",
    "Л":"L",
    "М":"M",
    "Н":"N",
    "О":"O",
    "П":"P",
    "Р":"R",
    "С":"S",
    "Т":"T",
    "У":"U",
    "Ф":"F",
    "Х":"H",
    "Ц":"Ts",
    "Ч":"Ch",
    "Ш":"Sh",
    "Щ":"Sht",
    "Ъ": "A",
    "Ю":"Yu",
    "Я":"Ya",
    "а":"a",
    "б":"b",
    "в":"v",
    "г":"g",
    "д":"d",
    "е":"e",
    "ж":"zh",
    "з":"z",
    "и":"i",
    "й":"y",
    "к":"k",
    "л":"l",
    "м":"m",
    "н":"n",
    "о":"o",
    "п":"p",
    "р":"r",
    "с":"s",
    "т":"t",
    "у":"u",
    "ф":"f",
    "х":"h",
    "ц":"ts",
    "ч":"ch",
    "ш":"sh",
    "щ":"sht",
    "ъ": "a",
    "ь":"y",
    "ю":"yu",
    "я":"ya"
}

// const cyrillicToLatinPlateMap = {
//     "0":"0",
//     "1":"1",
//     "2":"2",
//     "3":"3",
//     "4":"4",
//     "5":"5",
//     "6":"6",
//     "7":"7",
//     "8":"8",
//     "9":"9",
//     "А":"A",
//     "В":"B",
//     "С":"C",
//     "Р":"P",
//     "Е":"E",
//     "Х":"X",
//     "О":"O",
//     "Т":"T",
//     "К":"K",
//     "М":"M",
//     "Н":"H"
// }

export const getLatin = (wordInCyrillic) => {
        
    if (!wordInCyrillic) {
        return wordInCyrillic
    } else {
        const characters = wordInCyrillic.split('');
        return characters.reduce((acc, curr)=>{
                const latin = cyrillicToLatinMap[curr] ? cyrillicToLatinMap[curr] : "";
                return acc + latin;
        },"");
    }
}